import React, { Component } from "react";
import moment from "moment";

import Countdown from "react-countdown";
import { RiWifiLine, RiWifiOffLine } from "react-icons/ri";
import Loading from "../components/loading";
import { withTranslation } from "react-i18next";

class Welcome extends Component {
  state = {
    nom: "",
    prenom: "",
    mail: "",
    company: "",
    start_date: "",
    duration: 0,
    remain_time: 0,
    loading: true,
    connected: false,
  };
  componentDidMount() {
    if (!sessionStorage.getItem("reseau") && !sessionStorage.getItem("station_ip")) {
      window.location.replace(`${process.env.REACT_APP_BASE_API}home`);
    } else {
      document.title = `${this.props.t("welcome.header")} - Wifi Guest`;
      this.getGuestInfo();
    }
  }
  componentDidUpdate() {
    window.scrollTo(0, 0);
  }
  getRemainingTime() {
    this.setState({ loading: false });
    let date1 = new Date(moment(this.state.start_date, "DD/MM/YYYY").format("MM/DD/YYYY"));
    let date2 = new Date();
    // différence des heures
    let time_diff = date2.getTime() - date1.getTime();
    // différence de jours
    let days_Diff = time_diff / 1000;
    // calcul temps restant en secondes
    let remainTime = this.state.duration * 86400 - days_Diff;
    this.setState({ remain_time: remainTime });
  }
  getGuestInfo() {
    let queryString = this.props.location.search;
    let urlParams = new URLSearchParams(queryString);
    if (queryString !== "") {
      sessionStorage.setItem("nom", urlParams.get("nom"));
      sessionStorage.setItem("prenom", urlParams.get("prenom"));
      sessionStorage.setItem("mail", urlParams.get("mail"));
      sessionStorage.setItem("company", urlParams.get("company"));
      sessionStorage.setItem("start_date", urlParams.get("startAt"));
      sessionStorage.setItem("duration", urlParams.get("validity_period"));
      window.history.pushState("clear", "", "/welcome");
    }
    this.setState({ nom: sessionStorage.getItem("nom") });
    this.setState({ prenom: sessionStorage.getItem("prenom") });
    this.setState({ mail: sessionStorage.getItem("mail") });
    this.setState({ company: sessionStorage.getItem("company") });
    this.setState({ start_date: moment(sessionStorage.getItem("start_date")).format(this.props.t("date_format")) });
    this.setState({ duration: (sessionStorage.getItem("duration") / 86400).toString() }, () => {
      this.getRemainingTime();
    });
  }
  renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      if (this.state.connected) this.setState({ connected: false });
      return <span className="nowifi-error">{this.props.t("welcome.error")}</span>;
    } else {
      if (!this.state.connected) this.setState({ connected: true });
      return (
        <span className="countdown">
          {days}
          {this.props.t("welcome.countdown.d")} {hours}h {minutes}min {seconds}s
        </span>
      );
    }
  };
  calculMSecondes(nbSecondes) {
    return nbSecondes * 1000;
  }
  render() {
    const { t } = this.props;
    if (this.state.loading) {
      return (
        <div>
          <Loading />
        </div>
      );
    }
    return (
      <div className="auth-inner">
        <h3>
          {t("welcome.login")}
          {this.state.connected ? ` ${t("welcome.status.success")} ` : ` ${t("welcome.status.failed")} `}
          {this.state.connected ? <RiWifiLine className="connected" /> : <RiWifiOffLine className="not-connected" />}
        </h3>
        <br />
        <div className="form-group">
          <label>Guest</label>
          <div className="guest-info">
            {this.state.prenom} {this.state.nom}
            <br />
            {this.state.mail}
            <br />
            {this.state.company}
          </div>
          <label>{t("welcome.label.startAt")}</label>
          <br />
          <div className="guest-info">{this.state.start_date}</div>
          <label>{t("welcome.label.duration")}</label>
          <div className="guest-info">
            {this.state.duration} {t("welcome.day")}
          </div>
          <label>{t("welcome.label.remain_time")}</label>
          <br />
          <Countdown date={Date.now() + this.calculMSecondes(this.state.remain_time)} renderer={this.renderer} />
        </div>
      </div>
    );
  }
}

export default withTranslation()(Welcome);
